import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NavMenuItem } from '@core/types';
import { bottomNavigationMenuItems } from '@core/constants';
import { NgxBottomSheetService } from 'ngx-bottom-sheet';
import { filter } from 'rxjs/operators';
import { ShellService } from '@app/shell/services/shell.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AddElementComponent } from '@shared/components';

@UntilDestroy()
@Component({
  selector: 'app-bottom-navigation',
  templateUrl: './bottom-navigation.component.html',
  styleUrls: ['./bottom-navigation.component.scss'],
  standalone: false,
})
export class BottomNavigationComponent implements OnInit {
  activeItem: NavMenuItem | null = null;
  bottomNavigationItems: NavMenuItem[] = [];
  private readonly _router = inject(Router);
  private readonly _bottomSheetService = inject(NgxBottomSheetService);
  private readonly _shellService = inject(ShellService);

  constructor() {
    this.bottomNavigationItems = bottomNavigationMenuItems;
  }

  ngOnInit(): void {
    this._activeTab();

    this._router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this._activeTab();
        },
      });
  }

  setActiveItem(item: NavMenuItem): void {
    if (item.href === '/m/create') {
      this.openCreateElementSheet();
    } else {
      this._shellService.activateNavItem(this.bottomNavigationItems.indexOf(item), this.bottomNavigationItems);
      this._router.navigate([item.href]);
    }
  }

  openCreateElementSheet(): void {
    this._bottomSheetService.open(AddElementComponent, {
      height: '95%',
      showCloseButton: true,
      data: {
        title: 'Create Element',
      },
    });
  }

  private _activeTab(): void {
    this._shellService.activeNavTab(this.bottomNavigationItems);
  }
}
